import { BaseMapper } from '@shared/data';
import _ from 'lodash';
import { v4 } from 'uuid';
import { ClaimType } from '../../../../../core/enum/claims/claim-type.enum';
import { SubmittedAsType } from '../../../../../core/enum/claims/submitted-as-type.enum';
import { AttachmentModel } from '../../../../../core/interface/attachment-model';
import { CustomerReimbursementClaimModel } from '../../../../../core/interface/claims/customer-claims-model';
import { AttachmentDto } from '../../../interface/dto/attachment-dto';
import { ReimbursementClaimDto } from '../../../interface/dto/features/reimbursement/reimbursement-claim-dto';

export class ReimbursementClaimMapper extends BaseMapper<CustomerReimbursementClaimModel, ReimbursementClaimDto> {
    public mapDtoToModel(dto: ReimbursementClaimDto): CustomerReimbursementClaimModel {
        return {
            uuid: v4(),
            claimType: ClaimType.Reimbursement,
            isCancelable: false,
            submittedAs: _.find(SubmittedAsType, value => value.toLowerCase() === dto.submittedAs.toLowerCase()) as SubmittedAsType,
            claimId: dto.reimbursementId,
            medifitClaimId: dto.medifitReimbursementId ?? null,
            status: dto.status,
            description: dto.description ?? null,
            submittedAt: this.stringDateToDayjs(dto.submittedAt),
            updatedAt: this.stringDateToDayjs(dto.updatedAt),
            bankAccount: dto.bankAccount,
            bankName: dto.bankName,
            insurancePolicyNumber: dto.insurancePolicyNumber,
            attachments: dto.attachments ? dto.attachments.map(this.mapAttachmentDtoToModel.bind(this)) : null,
        };
    }

    private mapAttachmentDtoToModel(dto: AttachmentDto): AttachmentModel {
        return {
            documentId: dto.documentId,
            name: dto.name,
            mimeType: dto.mimeType,
            medifitDocumentId: dto.medifitDocumentId,
            documentType: dto.documentType,
        };
    }
}
